import { Box } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Text from 'commons/Text';
import { ReactComponent as IconButtonRadio } from 'images/icon_button_radio.svg';

import useStyles from '../styles';

const Collection = ({ listCollection }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const isVisibilityPublications = listCollection?.length;
  const maxLines = 3;

  const [showMore, setShowMore] = useState(false);

  const toggleShowMore = () => {
    setShowMore(!showMore);
  };
  if (!isVisibilityPublications) {
    return null;
  }

  const visibleEPublications = showMore ? listCollection : listCollection.slice(0, maxLines);

  return (
    <Box className={classes.boxWrapItemsProfile}>
      <div className={classes.iconButtonRadio}>
        <IconButtonRadio />
      </div>
      <div className={classes.wrapItemProfile}>
        <Box className={classes.boxItemProfile}>
          <Text
            type="xl"
            fontWeightBold
          >
            {t('institutional_collections')}
          </Text>
          <div className={classes.wrapListProfile}>
            {visibleEPublications.map((item, index) => (
              <div
                key={index}
                className={classes.wrapListItemProfile}
              >
                <Text fontWeightMedium>{item?.name}</Text>
              </div>
            ))}
          </div>
          {listCollection.length > maxLines && (
            <div className={classes.textSeeMore}>
              <Text
                bold
                onClick={toggleShowMore}
              >
                {showMore ? t('show_less') : t('see_more')}
              </Text>
            </div>
          )}
        </Box>
      </div>
    </Box>
  );
};

export default Collection;
